export default "__VITE_ASSET__NzN3Wopk__"